import { Component, OnInit } from "@angular/core";
import { AppSettings } from "src/app/app-settings";
import { CompanyService } from "src/app/api/company.service";

import { ViewChild, ElementRef } from "@angular/core";
import { Geolocation } from "@awesome-cordova-plugins/geolocation/ngx";

import { LoadingController } from "@ionic/angular";

declare var google: any;

@Component({
  selector: "app-map",
  templateUrl: "./map.page.html",
  styleUrls: ["./map.page.scss"],
})
export class MapPage implements OnInit {
  map: any;
  locationLng: any;
  locationLat: any;
  isWeb = AppSettings.IS_WEB;
  infoWindows: any = [];
  markers: any = [];
  wait: boolean = true;
  public isLoading: boolean = false;
  @ViewChild("map", { read: ElementRef }) mapRef: ElementRef;
  constructor(
    public companyService: CompanyService,
    public loadingCtrl: LoadingController // private geolocation: Geolocation
  ) { }
  ngOnInit() { }

  async ionViewDidEnter() {
    this.showMap();
  }

  // getCurrentLocation() {
  //   this.geolocation
  //     .getCurrentPosition({ timeout: 10000, enableHighAccuracy: true })
  //     .then((r) => {
  //       this.locationLat = r.coords.latitude;
  //       this.locationLng = r.coords.longitude;

  //       let position = new google.maps.LatLng(
  //         this.locationLat,
  //         this.locationLng
  //       );
  //       let mapMarker = new google.maps.Marker({
  //         position: position,
  //         title: "test",
  //         icon: {
  //           url: "../../../assets/icon/marker.png",
  //           scaledSize: new google.maps.Size(40, 40),
  //         },
  //       });

  //       mapMarker.setMap(this.map);
  //       this.addInfoWindowToMarker(mapMarker);
  //     });
  // }

  async addMarkersToMap() {
    let loader = await this.loadingCtrl.create({
      message: "Loading...",
    });
    loader.present();

    this.companyService.getCompaniesInfos().then((r) => {
      this.markers = r;
      this.markers.forEach((marker) => {
        let position;
        let icon;

        if (marker.latitude && marker.longitude) {
          position = new google.maps.LatLng(marker.latitude, marker.longitude);
          icon = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
          this.markPosition(position, marker, icon);
        }
        if (marker.warehouse_latitude && marker.warehouse_longitude) {
          position = new google.maps.LatLng(marker.warehouse_latitude, marker.warehouse_longitude);
          icon = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
          this.markPosition(position, marker, icon);
        }


      });
    })
      .finally(() => {
        loader.dismiss();
      })
      .catch(() => {
        this.loadingCtrl.dismiss();
      });
  }


  markPosition(position, marker, icon) {
    if (position) {
      let mapMarker = new google.maps.Marker({
        position: position,
        title: marker.name,
        icon: icon,
      });
      mapMarker.setMap(this.map);
      this.addInfoWindowToMarker(mapMarker, marker);
    }
  }

  addInfoWindowToMarker(marker, company) {
    let infoMarkerContent = `<div>
      <ion-scroll>
      <ion-list>
      <ion-item>
      <ion-label>
      <h2>Organization</h2>
      <h4>${company.name}</h4>
    </ion-label>
      </ion-item>
      <ion-item>
      <ion-label>
      <h2>Website</h2>
      <a href=${company.website}>${company.website}</a>
    </ion-label>
      </ion-item>
      <ion-item>
      <ion-label>
      <h2>Address</h2>
      <h4>${company.address}.</h4>
    </ion-label>
      </ion-item>
      <ion-item>
      <ion-label>
      <h2>Phone Number</h2>
      <h4>${company.phone}</h4>
    </ion-label>
      </ion-item>
    </ion-list> </ion-scroll></div>`;

    let infoMarker = new google.maps.InfoWindow({
      content: infoMarkerContent,
    });

    marker.addListener("click", () => {
      this.closeAllInfoWindows();
      infoMarker.open(this.map, marker);
    });

    this.infoWindows.push(infoMarker);
  }

  closeAllInfoWindows() {
    for (let window of this.infoWindows) {
      window.close();
    }
  }

  showMap() {
    const location = new google.maps.LatLng(37.09024, -95.712891);
    const options = {
      center: location,
      zoom: 4,
      disableDefaultUI: true,
    };

    this.map = new google.maps.Map(this.mapRef.nativeElement, options);

    this.addMarkersToMap();
  }
}
